import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function DeliveryBoxEmptyIcon(props) {
  return (
    <SvgIcon viewBox="0 0 60 60" {...props}>
      <title>Delivery Box Empty</title>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36.9425 7.5L30.785 16.9525L24.1975 7.7L2.5 14.555L10.1625 24.5275L10.1475 24.5325V45.3175L30.6975 52.6L51.435 44.825L51.5125 24.4675L57.4975 14.8925L36.9425 7.5ZM34.135 16.2325L37.9225 10.42L53.535 16.0325L49.7725 21.9075L34.135 16.2325ZM6.52 15.8225L23.25 10.5325L27.3825 16.3425L11.595 22.4275L6.52 15.8225ZM13.86 24.97L30.8975 18.7275L47.835 24.315L30.495 30.6L13.86 24.97Z"
        />
      </g>
    </SvgIcon>
  );
}

export default DeliveryBoxEmptyIcon;
